<template>
  <el-form ref="form" :model="ruleForm" label-width="100px" :rules="rules">
    <el-form-item label="角色名称" prop="role_name">
      <el-input v-model="ruleForm.role_name" />
    </el-form-item>

    <el-form-item label="备注" prop="remark">
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="ruleForm.remark">
      </el-input>
    </el-form-item>
    <el-form-item style="text-align:left;">
      <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
      <el-button class="btn_dialog cz" @click="onReset">重置</el-button>
      <el-button class="btn_dialog qd" @click="onOk">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Backend from '@/api/backend'

export default {
  data () {
    return {
      service: 'role',
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: ['blur', 'change'] }
        ]
      },
      ruleForm: {
        role_name: '',
        remark: ''
      }
    }
  },

  methods: {
    onReset () {
      this.$refs.form.resetFields()
    },
    onOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          Backend.insertRow(this, this.ruleForm, undefined)
        }
      })
    }
  }
}
</script>
